import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsAmenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';
import {Response, Headers, Http, RequestOptions} from '@angular/http';
import { environment } from '../../../../environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'settings-amenities-modal',
    templateUrl: './settings-amenities-modal.component.html',
    styleUrls: ['./settings-amenities-modal.component.scss']
})
export class SettingsAmenitiesModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: SettingsAmenity = new SettingsAmenity();
    disabledSubmit = false;
    disabledFileInput = false;
    attachments: Array<any> = [];
    disabledDates: Array<any> = [];
    startDate = null;
    endDate = null;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };
    uses = [''];
    amenityImageBasePath = '../../assets/img/amenity-icons-svg/';
    displayedAmenityImage = 'bbq.svg';
    amenityImages = ['bbq.svg', 'fitness.svg', 'golf.svg', 'guestsuite.svg', 'hobby_room.svg', 'spa.svg',
                     'mediaroom.svg', 'meeting_room.svg', 'party_room.svg', 'pinpong.svg', 'kids_room.svg',
                     'pool_table.svg', 'saunas.svg', 'service_elevator1.svg', 'swimingpool_indoor.svg',
                     'swimingpool_outdoor.svg', 'tennis.svg', 'tv_room.svg', 'elevator.svg', 'library.svg'];

    constructor(
      public api: ApiClientService,
      public settingsAmenitiesService: SettingsAmenitiesService,
      public authService: AuthenticationService,
      public urlService: UrlService,
      private http: Http,
      private authTokenService: AuthTokenService
    ) {}

    ngOnInit() {
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsAmenitiesService.isSettingsAmenitiesModalShow = false;
                    this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsAmenitiesService.isSettingsAmenitiesModalShow = false;
            this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            if (!form.value.buildings || form.value.buildings.length == 0) toastr.warning('Buildings should not be blank.');
            return;
        }
        const name = form.value.name;
        const buildings = form.value.buildings;

        if (!name) {
            toastr.warning('Name is not set.');
            return;
        }
        if (!buildings || buildings.length == 0) {
            toastr.warning('Buildings are not set.');
            return;
        }
        let oneIsEmpty = false;
        let noUseIsSet = false;
        for (let i = 0; i < this.uses.length; i++) {
            if (this.uses[i] == '' && this.uses.length == 1) {
                noUseIsSet = true;
                break;
            }
            if (this.uses[i] == '' || this.uses[i].replace(/&nbsp;/g, '').replace(/\s/g, '') == '') {
                oneIsEmpty = true;
            }
        }
        if (oneIsEmpty) {
            toastr.warning('Use can not be empty or only contain spaces');
            return;
        }

        let data: any = {
            name: form.value.name,
            internalId: form.value.internalId,
            buildingAmenity: this.buildingAmenityFormatConvertion(this.data.buildingAmenity),
            allowResidentsToBook: form.value.allowResidentsToBook,
            requiresManagerApproval: form.value.requiresManagerApproval,
            legalAgreement: form.value.legalAgreement,
            legalAgreementStatus: form.value.legalAgreementStatus,
            disclaimer: form.value.disclaimer,
            disclaimerStatus: form.value.disclaimerStatus,
            amenityImage: this.data.amenityImage,
            multipleBooking: form.value.multipleBooking,
            multipleBookingMaxCount: form.value.multipleBookingMaxCount,
            enableStatus: 0,
            amenityColor: '#1ab394'
        };
        if (this.uses.length > 0 && !noUseIsSet)
            data.uses = this.uses;
        else if(noUseIsSet)
            data.uses = [];

        this.disabledSubmit = true;

        this.api.post('domainAmenities', '/v1/amenity.json', data).subscribe(
            () => this.updateView('Amenity successfully created'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create Amenity failed');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsAmenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    addNewUse(index) {
        this.uses.splice(index + 1, 0, '');
    }

    removeUse(index) {
        if (this.uses.length > 1)
            this.uses.splice(index, 1);
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    buildingAmenityFormatConvertion(buildings): any {
        let formated = [];
        buildings.forEach((b) => {
            const building = this.settingsAmenitiesService.buildings.find(bld => bld.id == b.id);
            formated.push({
                buildingId: b.id,
                buildingName: building.name,
                address: building.address,
                corporationNumberBd: building.corporationNumber.id,
                corporationNumberName: building.corporationNumber.name,
                timezone: b.timezone
            });
        });
        return formated;
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsAmenitiesService.buildings.forEach(building => {
            if (building.id == id)
                name = building.name;
        });

        return name;
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 1000000) {
            toastr.warning('Maximum image size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.settingsAmenitiesService.modalSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Image path should not be blank.');
                    return;
                }
                this.data.amenityImage = res.path;
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => {
                this.settingsAmenitiesService.modalSpinnerShow = false;
                this.disabledFileInput = false;
            }
        );
    }

    showNextAmenityImage() {
        const index = this.amenityImages.indexOf(this.displayedAmenityImage);
        this.displayedAmenityImage = this.amenityImages[index < this.amenityImages.length - 1 ? (index + 1) : 0];
    }

    showPreviousAmenityImage() {
        const index = this.amenityImages.indexOf(this.displayedAmenityImage);
        this.displayedAmenityImage = this.amenityImages[index > 0 ? (index - 1) : (this.amenityImages.length - 1)];
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-modal/settings-amenities-modal.component.ts